// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.panel-content-container {
  display: flex;
  margin: 0 8px;
  width: auto;
  align-items: center;
}
.panel-content-container .right-graph {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px dotted var(--divider-color);
  box-sizing: content-box;
  align-items: center;
  width: 100%;
}
.panel-content-container.margin-all {
  margin: 8px;
}
.panel-content-container.no-margin-x {
  margin-left: 0;
  margin-right: 0;
}
.panel-content-container .fill {
  flex-grow: 1;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.panel-content-container .content {
  flex-shrink: 0;
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./package/nextgisweb/nextgisweb/webmap/nodepkg/panel/identification/PanelContentContainer.less"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,aAAA;EACA,WAAA;EACA,mBAAA;AADJ;AAHA;EAOQ,aAAA;EACA,8BAAA;EACA,8CAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;AADR;AAII;EACI,WAAA;AAFR;AAKI;EACI,cAAA;EACA,eAAA;AAHR;AAlBA;EAyBQ,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AAJR;AAxBA;EAgCQ,cAAA;EACA,mBAAA;AALR","sourcesContent":["@margin-default: 8px;\n\n.panel-content-container {\n    display: flex;\n    margin: 0 @margin-default;\n    width: auto;\n    align-items: center;\n\n    .right-graph {\n        display: flex;\n        justify-content: space-between;\n        border-bottom: 1px dotted var(--divider-color);\n        box-sizing: content-box;\n        align-items: center;\n        width: 100%;\n    }\n\n    &.margin-all {\n        margin: @margin-default;\n    }\n\n    &.no-margin-x {\n        margin-left: 0;\n        margin-right: 0;\n    }\n\n    .fill {\n        flex-grow: 1;\n        overflow: hidden;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n    }\n\n    .content {\n        flex-shrink: 0;\n        white-space: nowrap;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
